// src/components/EquipmentBadges.js
import React from 'react';

/**
 * EquipmentBadges — renders a list of required equipment as styled badge tags.
 * Conditionally hidden when the equipment list is empty or absent.
 *
 * @param {Object} props
 * @param {string[]} props.equipment - Array of equipment name strings
 * @param {'compact'|'full'} [props.variant='full'] - Display variant
 */
const EquipmentBadges = ({ equipment, variant = 'full' }) => {
    // Guard: hide entirely when no equipment data
    if (!equipment || !Array.isArray(equipment) || equipment.length === 0) {
        return null;
    }

    if (variant === 'compact') {
        return (
            <div className="flex flex-wrap items-center gap-1.5" data-testid="equipment-badges">
                {equipment.map((item, index) => (
                    <span
                        key={index}
                        className="inline-flex items-center gap-1 bg-amber-500/15 text-amber-400 border border-amber-500/30 px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap"
                    >
                        <svg className="w-3 h-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                        {item}
                    </span>
                ))}
            </div>
        );
    }

    // Full variant — used in session player header
    return (
        <div className="flex flex-col items-center gap-2" data-testid="equipment-badges">
            <span className="text-xs font-bold uppercase tracking-widest text-gray-400">
                Equipment Required
            </span>
            <div className="flex flex-wrap justify-center gap-2">
                {equipment.map((item, index) => (
                    <span
                        key={index}
                        className="inline-flex items-center gap-1.5 bg-amber-500/15 text-amber-300 border border-amber-500/25 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm shadow-sm"
                    >
                        <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                        {item}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default EquipmentBadges;
